import React from 'react';
import { useEffect, useState } from "react";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import DocumentCard from './DocumentCard'; // Assuming you have a DocumentCard component
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';

import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { WithContext as ReactTags } from 'react-tag-input';




const darkTheme = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: "50vh",
  },
  modalContent: {
    backgroundColor: '#343a40',
    padding: '24px', // Increased padding
    borderRadius: '8px',
    color: '#000',
    width: '50%', // Increased width
    maxHeight: '80%', // Set maximum height
    overflowY: 'auto', // Enable vertical scrolling if needed
  },
  documentCard: {
    backgroundColor: '#000',
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '16px',
  },
};

const suggestions = [
    { id: "1", name: "Revenue" },
    { id: "2", name: "Future Outlook"},
    { id: "3", name: "Market Competition"}
];

const FinchatTopicModal = ({ open, handleClose, topics, handleDelete, handleAddition, handleDrag, handleTagClick, handleClicksubmitTopics}) => {


  return (
    <Modal
      aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      // BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={darkTheme.modal}
      id="delv-modal"
    >
      <Fade in={open}>
        <Box sx={darkTheme.modalContent} >
        <Box sx={{display: "flex", alignItems: "center"}}>

          <Typography id="spring-modal-title" sx={{display:"inline"}} variant="h6" component="h2">
            Add Topics
          </Typography>
          &nbsp;
          
          <Tooltip placement="right-start" arrow title={"Add topics for summary." } >
            <HelpOutlineIcon  iconposition="end" sx={{color: "#fff"}} />
          </Tooltip>
          <Tooltip placement="right-start" arrow title='close modal' >
            <CloseIcon sx={{ cursor: 'pointer', marginLeft: 'auto', float:"right", color: "#fff" }} onClick={handleClose}/>
          </Tooltip >
        </Box >
          
        <Box sx = {{mb:1, mt:1}}>
        <ReactTags
          tags={topics}
          classNames={{
            tags: 'topic__tagsClass',
            tagInput: 'topic__tagInputClass',
            tagInputField: 'topic__tagInputFieldClass',
            selected: 'topic__selectedClass',
            tag: 'topic__tagClass',
            remove: 'topic__removeClass',
            suggestions: 'topic__suggestionsClass',
            activeSuggestion: 'topic__activeSuggestionClass',
            editTagInput: 'topic__editTagInputClass',
            editTagInputField: 'topic__editTagInputField',
            clearAll: 'topic__clearAllClass',
          }}
        //   suggestions={suggestions}
        //   delimiters={delimiters}
          handleDelete={handleDelete}
          handleAddition={handleAddition}
          handleDrag={handleDrag}
          handleTagClick={handleTagClick}
          inputFieldPosition="bottom"
          autocomplete
        />
      </Box>

        <div className="modal-footer">
            <button className="btn secondary_btn" onClick={handleClicksubmitTopics}>Save</button>
        </div>
        </Box>
      </Fade>
    </Modal>
  );
};

export default FinchatTopicModal;